import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import ElementUI from 'element-ui';
import axios from '@/axios/index';
import todo from '@/utils/common';
import API from '@/axios/API';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/styles/index.css'
import "./utils/draggable";
Vue.use(ElementUI);
Vue.use(VueSweetalert2);
Vue.use(VModal, { dynamicDefault: { draggable: true, resizable: true } })
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$API = API;
Vue.prototype.$bus = new Vue();
Vue.prototype.$todo = todo;
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Caught an error:', err);
  console.error('Error details:', info);
  };
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
